import { Route, Switch } from 'react-router-dom';
import _ from 'lodash';

// route components
import PublicRoute from './routeWrappers/PublicRoute';
import OnlyGuestRoute from './routeWrappers/OnlyGuestRoute';
import UserRoute from './routeWrappers/UserRoute';

// components
import Login from 'pages/Login';
import NotFound from 'pages/NotFound';
import Dashboard from 'pages/Dashboard';

export const routes = [
  { path: '/dashboard', component: Dashboard, access: 'user', exact: true },
  { path: ['/login', '/'], component: Login, access: 'onlyGuest', exact: true },
  { path: '/404', component: NotFound, access: 'public' },
];

export const pathnames = _.flatten(_.map(routes, 'path'));

export const createRoutes = (routes) => {
  if (routes.length < 1) return null;
  return (
    <Switch>
      {routes.map(({ access, path, component: Component, exact }, idx) => {
        if (routes.length === idx + 1) {
          return <Route component={NotFound} key={path + idx} />;
        }
        switch (access) {
          case 'public':
            return (
              <PublicRoute
                key={path + idx}
                path={path}
                component={Component}
                exact={exact}
              />
            );
          case 'onlyGuest':
            return (
              <OnlyGuestRoute
                key={path + idx}
                path={path}
                component={Component}
                exact={exact}
              />
            );
          case 'user':
            return (
              <UserRoute
                key={path + idx}
                path={path}
                component={Component}
                exact={exact}
              />
            );
          default:
            console.error('ACCESS LEVEL NOT DEFINED');
            return (
              <Route
                key={path + idx}
                path={path}
                component={NotFound}
                exact={exact}
              />
            );
        }
      })}
    </Switch>
  );
};
